import React from 'react';

import {
  Box,
  Button,
  ModalBody,
  ModalCloseButton,
  ModalHeader,
  Text,
} from '@chakra-ui/react';

import { EGTMEvents, useGTMDataLayer } from '../../../../hooks';
import { generateMonolithUrl } from '../../../../Navigation/utils';
import { EButtonVariant } from '../../../../Theme';
import { tracker } from '../../../../utilities/tracker';
import { useModalContext } from '../../../hooks/useModalContext';
import { useModalStore } from '../../../stores';
import { EModalContent } from '../../../types';

export const CollectLogin = () => {
  const { fanaticsCollectBaseUrl } = useModalContext();
  const modalStore = useModalStore();
  const loginLookup = modalStore.lookup<EModalContent.COLLECT_LOGIN>();
  const redirectUrl = loginLookup?.redirectUrl
    ? encodeURIComponent(loginLookup?.redirectUrl)
    : undefined;
  const loginPath = `/auth/login${
    redirectUrl ? `?redirectUrl=${redirectUrl}` : ''
  }`;
  const registerPath = `/auth/register${
    redirectUrl ? `?redirectUrl=${redirectUrl}` : ''
  }`;

  const loginUrl = generateMonolithUrl(fanaticsCollectBaseUrl, loginPath);
  const registerUrl = generateMonolithUrl(fanaticsCollectBaseUrl, registerPath);

  const pushGTMData = useGTMDataLayer();

  return (
    <>
      <ModalHeader
        alignItems="center"
        borderBottom="1px solid"
        borderBottomColor="gray.200"
        display="flex"
        h="60px"
        justifyContent="space-between"
        p="16px"
        w="full"
      >
        <Box />
        <Text fontSize="lg" fontWeight="semibold">
          Create your account
        </Text>
        <ModalCloseButton position="static" size="sm" />
      </ModalHeader>
      <ModalBody display="flex" flexDirection="column" gap="32px" p="16px">
        <Text color="black" fontSize="md">
          Bid and buy, join live breaks, manage your collection, and experience
          everything Fanatics has to offer—all with your Fanatics ONE account.
        </Text>
        <Box display="flex" flexDirection="column" gap="12px">
          <Button
            as="a"
            fontFamily="ABC Diatype"
            fontSize="md"
            fontWeight="bold"
            textTransform="none"
            variant={EButtonVariant.BRAND_PRIMARY}
            width="100%"
            onClick={() => {
              pushGTMData({ event: EGTMEvents.CREATE_ACCOUNT });
              tracker.track('Sign Up Create Account Button Tapped', {});
              window.location.href = registerUrl;
            }}
          >
            Create Fanatics ONE account
          </Button>
          <Button
            as="a"
            borderColor="#E8E9E9"
            fontFamily="ABC Diatype"
            fontSize="md"
            fontWeight="bold"
            textTransform="none"
            variant={EButtonVariant.BRAND_SECONDARY}
            width="100%"
            onClick={() => {
              pushGTMData({ event: EGTMEvents.LOGIN });
              window.location.href = loginUrl;
            }}
          >
            Already have an account? Sign in
          </Button>
        </Box>
      </ModalBody>
    </>
  );
};
